import React from 'react';
import './About.css';

const About = () => {
  const stats = [
    { number: '50M+', label: 'Downloads' },
    { number: '100+', label: 'Games Published' },
    { number: '4.8', label: 'Average Rating' },
    { number: '2018', label: 'Founded' }
  ];

  const features = [
    {
      icon: '🎯',
      title: 'Player-Focused Design',
      description: 'We create games that are easy to learn but hard to master, ensuring maximum player engagement and retention.'
    },
    {
      icon: '📱',
      title: 'Cross-Platform Excellence',
      description: 'Our games are optimized for both iOS and Android platforms, reaching the widest possible audience.'
    },
    {
      icon: '💰',
      title: 'Monetization Expertise',
      description: 'Advanced monetization strategies that maximize revenue while maintaining excellent user experience.'
    },
    {
      icon: '🚀',
      title: 'Rapid Development',
      description: 'Fast development cycles allow us to quickly iterate and bring new engaging content to market.'
    }
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-header">
          <h2 className="section-title">About Xi'an Jiutian Chuangxiang Network Technology Co., Ltd.</h2>
          <p className="section-subtitle">
            Leading the hyper-casual gaming industry with innovative, engaging, and profitable mobile games
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3>Who We Are</h3>
            <p>
              Xi'an Jiutian Chuangxiang Network Technology Co., Ltd. is a pioneering game development 
              company based in Xi'an, China. Since our founding, we have been dedicated to creating 
              exceptional hyper-casual games that captivate players worldwide.
            </p>
            <p>
              Our team of passionate developers, designers, and marketers work together to craft 
              games that not only entertain but also generate substantial revenue through strategic 
              monetization approaches.
            </p>
            <p>
              With a deep understanding of mobile gaming trends and player behavior, we consistently 
              deliver titles that achieve high rankings on both Google Play and the App Store.
            </p>
          </div>

          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
